import { lazy } from 'react';
import GetWhitelistedModal from './GetWhitelisted/GetWhitelisted';
import ManualOrderModals from './ManualOrderModals/ManualOrderModals';

import {
  SIGN_UP_MODAL,
  LOGIN_MODAL,
  SOCIAL_MODAL,
  MOBILE_SOCIAL_MODAL,
  EDIT_ABOUT_MODAL,
  SEND_TICKETS_MODAL,
  END_POOL_MODAL,
  JOIN_POOL_MODAL,
  PARTICIPATION_MODAL,
  REDEEM_MODAL,
  EDIT_TOKENS_MODAL,
  CREATE_HPOOL_SIGN_TX_MODAL,
  USER_REDEEM_HPOOL_TOKENS_MODAL,
  HORD_SUPPORTED_TOKENS_MODAL,
  GET_WHITELISTED_MODAL,
  MANUAL_SWAPS_MODAL,
  MANUAL_ORDERS_MODAL,
  ADD_PROJECT_MODAL,
} from './modalTypes';

const TwitterSignUpModal = lazy(() => import('./Twitter/TwitterSignUpModal/TwitterSignUpModal'));
const TwitterLoginModal = lazy(() => import('./Twitter/TwitterLoginModal/TwitterLoginModal'));
const AddSocialsModal = lazy(() => import('./AddSocialsModal/AddSocialsModal'));
const MobileSocialsModal = lazy(() => import('./MobileSocialsModal/MobileSocialsModal'));
const EditAboutModal = lazy(() => import('./EditAboutModal/EditAboutModal'));
const SendTicketsModal = lazy(() => import('./SendTicketsModal/SendTicketsModal'));
const EndPoolModal = lazy(() => import('./EndPoolModal/EndPoolModal'));
const JoinPoolModal = lazy(() => import('./JoinPoolModal/JoinPoolModal'));
const ParticipationModal = lazy(() => import('./ParticipationModal/ParticipationModal'));
const RedeemModal = lazy(() => import('./RedeemModal/RedeemModal'));
const HordSupportedTokens = lazy(() => import('./HordSupportedTokens/HordSupportedTokens'));
const UserRedeemHPoolTokensModal = lazy(() => import('./UserRedeemHPoolTokensModal/UserRedeemHPoolTokensModal'));
const EditTokensModal = lazy(() => import('./EditTokensModal/EditTokensModal'));
const CreateHPoolSignTxModal = lazy(() =>
  import('../Pages/CreateHPool/CreateHPoolSignTransaction/CreateHPoolSignTransaction'),
);
const ManualSwapsModal = lazy(() => import('./ManualSwapsModal/ManualSwapsModal'));
const AddProjectModal = lazy(() => import('./AddProjectModal/AddProjectModal'));

// import WalletModal from './WalletModal/WalletModal';
// import TwitterSignUpModal from './Twitter/TwitterSignUpModal/TwitterSignUpModal';
// import TwitterLoginModal from './Twitter/TwitterLoginModal/TwitterLoginModal';
// import AddSocialsModal from './AddSocialsModal/AddSocialsModal';
// import MobileSocialsModal from './MobileSocialsModal/MobileSocialsModal';
// import EditAboutModal from './EditAboutModal/EditAboutModal';
// import SendTicketsModal from './SendTicketsModal/SendTicketsModal';
// import EndPoolModal from './EndPoolModal/EndPoolModal';
// import JoinPoolModal from './JoinPoolModal/JoinPoolModal';
// import RedeemModal from './RedeemModal/RedeemModal';
// import EditTokensModal from './EditTokensModal/EditTokensModal';

export default {
  [SIGN_UP_MODAL]: TwitterSignUpModal,
  [LOGIN_MODAL]: TwitterLoginModal,
  [SOCIAL_MODAL]: AddSocialsModal,
  [MOBILE_SOCIAL_MODAL]: MobileSocialsModal,
  [EDIT_ABOUT_MODAL]: EditAboutModal,
  [SEND_TICKETS_MODAL]: SendTicketsModal,
  [END_POOL_MODAL]: EndPoolModal,
  [JOIN_POOL_MODAL]: JoinPoolModal,
  [PARTICIPATION_MODAL]: ParticipationModal,
  [REDEEM_MODAL]: RedeemModal,
  [USER_REDEEM_HPOOL_TOKENS_MODAL]: UserRedeemHPoolTokensModal,
  [EDIT_TOKENS_MODAL]: EditTokensModal,
  [MANUAL_ORDERS_MODAL]: ManualOrderModals,
  [CREATE_HPOOL_SIGN_TX_MODAL]: CreateHPoolSignTxModal,
  [HORD_SUPPORTED_TOKENS_MODAL]: HordSupportedTokens,
  [GET_WHITELISTED_MODAL]: GetWhitelistedModal,
  [MANUAL_SWAPS_MODAL]: ManualSwapsModal,
  [ADD_PROJECT_MODAL]: AddProjectModal,
};

export const CREATE_HPOOL_ACTIONS = {
  createHPool: 'createHPool',
  assignNFT: 'assignNFT',
  updateHPool: 'updateHPool',
  submitHPool: 'submitHPool',
  addFunds: 'addFunds',
};
